import { Route, Routes } from "react-router-dom";

// Direct imports instead of lazy loading
import Login from "../pages/login/login";
import SignUp from "../pages/signUp/signUp";
import GeneralAdmin from "../pages/generalAdmin/GeneralAdmin";
import NotFound from "../pages/notFound";
import TotalTeachers from "../pages/totalTeachers/totalTeachers";
import TotalStudents from "../pages/totalStudents/totalStudents";
import ProfileSeting from "../pages/profileSetting/profileSetting";
import Classes from "../pages/classes/layout";
import Wallet from "../pages/wallet";
import SessionsHistory from "../pages/session-history";
import StudentTransactions from "../pages/student-transactions";
import TeacherTransactions from "../pages/teacher-transactions";
import Reports from "../pages/reports";
import BlogDetails from "../pages/landing-page/blog-details";
import BlogForm from "../pages/landing-page/blog-details/components/BlogForm";
import BlogView from "../pages/landing-page/blog-details/components/BlogView";
import BlogFeatured from "../pages/landing-page/blog-featured";
import Notifications from "../pages/warning/warning";
import FeaturedTeachers from "../pages/featured-teachers";
import SubscriptionOffers from "../pages/subsription-offers";

const routeConfig = [
  {
    path: "/",
    component: Login,
    protected: "",
  },
  {
    path: "/signup",
    component: SignUp,
    protected: "",
  },
  {
    path: "/admin",
    component: GeneralAdmin,
    protected: "",
  },
  {
    path: "/notfound",
    component: NotFound,
    protected: "",
  },
  {
    path: "/total-teachers/:id",
    component: TotalTeachers,
    protected: "",
  },
  {
    path: "/total-students",
    component: TotalStudents,
    protected: "",
  },
  {
    path: "/reports",
    component: Reports,
    protected: "",
  },
  {
    path: "/classes/*",
    component: Classes,
    protected: "",
  },
  {
    path: "/profile-setting",
    component: ProfileSeting,
    protected: "",
  },
  {
    path: "/notifications/:id",
    component: Notifications,
    protected: "",
  },
  {
    path: "/wallet",
    component: Wallet,
    protected: "",
  },
  {
    path: "/student-transactions",
    component: StudentTransactions,
    protected: "",
  },
  {
    path: "/teacher-transactions",
    component: TeacherTransactions,
    protected: "",
  },
  {
    path: "/sessions-history",
    component: SessionsHistory,
    protected: "",
  },
  {
    path: "/blog-details",
    component: BlogDetails,
    protected: "",
  },
  {
    path: "/blog-details/create",
    component: BlogForm,
    protected: "",
  },
  {
    path: "/blog-details/view/:id",
    component: BlogView,
    protected: "",
  },
  {
    path: "/blog-details/edit/:id",
    component: BlogForm,
    protected: "",
  },
  {
    path: "/featured-blogs",
    component: BlogFeatured,
    protected: "",
  },
  {
    path: "/featured-teachers",
    component: FeaturedTeachers,
    protected: "",
  },
  {
    path: "/subscription-offers",
    component: SubscriptionOffers,
    protected: "",
  },
];

const Router = () => {
  return (
    <Routes>
      {routeConfig.map((route, index) => (
        <Route key={index} path={route.path} element={<route.component />} />
      ))}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default Router;
